module.exports = __webpack_public_path__ + "static/ArchiveVideo03-87b720af1ab1eb06c4b1a55a081fd234.mp4";